import { useEffect, useState } from "react";
import styles from "./OptionsGroup.module.scss";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Radio } from "@mui/material";

const OptionsGroup = (props) => {
  const { name, options, optionProps, optGpIndex } = props;

  return (
    <div className={styles["options-group"]}>
      <p>{name}</p>
      {options.map((opt, i) => {
        return <Options key={opt.id} id={opt.id} opt={opt} {...optionProps} optGpIndex={optGpIndex} optIndex={i} />;
      })}
    </div>
  );
};

const Options = (props) => {
  const { opt, selectedOption, setSelectedOption, setValue, setPrice, setDirty, optGpIndex, optIndex } = props;
  const { id, description, price } = opt;
  const [checked, setChecked] = useState(selectedOption === id);

  const handleButtonOnChanged = async () => {
    setDirty(true);
    setValue("option", opt);
    setValue("skuIndex", optGpIndex);
    setValue("optionIndex", optIndex);
    setPrice(opt.price);
    setSelectedOption(id);
  };

  return (
    <div className={`${styles["options-group-option"]} ${checked ? "option-checked" : ""}`} onClick={handleButtonOnChanged}>
      <div className={styles["button-group"]}>
        <Radio checked={checked} onChange={handleButtonOnChanged} value={id} name="opt_radio_btn" />
      </div>
      <div className={styles["text-div"]}>
        <p>{description}</p>
        <p>{price ? `HKD ${price}` : "-"}</p>
      </div>
    </div>
  );
};

export default OptionsGroup;
